import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=3c388fb0&scoped=true"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=3c388fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c388fb0",
  null
  
)

export default component.exports